<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <article v-show="!loading">
        <section class="section white-panel mb2p">
          <h3 class="section-title" style="padding-top: 10px;">車検証情報</h3>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">自動車登録番号<br>または車両番号</dt>
            <dd class="pt8">
              <p>{{car.plate_number}}</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">車検満了日</dt>
            <dd class="pt8">
              <p>{{expiryOnWareki.gengo}}{{expiryOnWareki.year}}年{{expiryOnWareki.month}}月{{expiryOnWareki.date}}日</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">初度登録年月</dt>
            <dd class="pt8">
              <p>{{firstRegistrationOnWareki.gengo}}{{firstRegistrationOnWareki.year}}年{{firstRegistrationOnWareki.month}}月</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">車名（メーカー）</dt>
            <dd class="pt8">
              <p>{{manufacturerName}}</p>
            </dd>
          </dl>
          <dl class="dl estimate-list" style="padding-top: 30px;">
            <dt class="fs16 pt8">車両重量</dt>
            <dd class="pt8">
              <p>{{car.weight}}kg</p>
            </dd>
          </dl>
        </section>
     </article>
     <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="this.$route.query.tsid">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="this.$route.query.popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="this.$route.query.otoken">
      <input id="ss_code" type="hidden" name="ss_code" v-bind:value="this.$route.query.ssCode">
      <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.$route.query.appVersion">
      <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.$route.query.platform">
      <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.$route.query.osVersion">
    </form>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import carApi from '@/store/Api/car'
import manufacturerApi from '@/store/Api/manufacturers'
import Loading from '@/views/v3/Loading.vue'
import modal from '@/assets/v3/modal'

export default {
  data: () => ({
    loading: true,
    manufacturers: [],
    manufacturerName: '',
    expiryOnWareki: '',
    firstRegistrationOnWareki: ''
  }),
  methods: {
    ...mapActions('CAR', [
      'setCar'
    ]),
    setManufacturer (manufacturers) {
      this.manufacturers = manufacturers
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  computed: {
    ...mapGetters('CAR', [
      'car'
    ])
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false

    const tsId = this.$route.query.tsid
    const carId = Number(this.$route.query.carid)

    await manufacturerApi.get().then(res => {
      this.setManufacturer(res.data.manufacturer)
    }).catch(e => {
      console.log('manufacturerApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 端末毎の車検証データを取得
    await carApi.get(tsId).then(res => {
      if (res.data.car.length > 0) {
        for (let i = 0; i < res.data.car.length; i++) {
          // car_idと一致する車検証番号を取得
          if (res.data.car[i].id === carId) {
            this.setCar(res.data.car[i])
            // 初度登録年月を和暦に変換
            this.firstRegistrationOnWareki = this.toWareki(this.car.first_registration_on)
            // 車検満了日を和暦に変換
            this.expiryOnWareki = this.toWareki(this.car.expiry_on)
            break
          }
        }
        this.manufacturers.forEach(element => {
          if (element.id === this.car.manufacturer_id) {
            this.manufacturerName = element.manufacturer_name
          }
        })
      }
    }).catch(e => {
      console.log('carApi-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    this.loading = false
  },
  components: {
    Loading
  }
}
</script>
